<template>
  <div style="margin-bottom: 0" v-if="subcategory">
    <template v-if="editText">
      <div class="text-xs-center" v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
      <div v-else>
        <v-layout wrap class="pa-2">
          <v-flex xs12 sm3 class="form-control">
            <div class="pb-3 form-control" :class="{ 'has-error': errors.has('subcategoryphoto') }">
              <uploadfile
                :data-vv-as="$t('subcategoryphoto')"
                name="Photo URL"
                v-validate="`excluded: ${subcategoryphoto}`"
                v-model="subcategory.photo_url"
                style="max-width: 250px"
              ></uploadfile>

              <div class="text-error" v-show="errors.has('subcategoryphoto')">
                {{ errors.first('subcategoryphoto') }}
              </div>
            </div>
          </v-flex>
          <v-flex xs12 sm9 class="form-control">
            <div
              class="category-name form-control"
              :class="{ 'has-error': errors.has('subcategoryname') }"
              style="width: 100%"
            >
              <input
                v-validate="`excluded: ${subcategoryname}`"
                ref="subcategory"
                type="text"
                name="subcategoryname"
                :data-vv-as="$t('Sub Category name')"
                v-model="subcategory.name"
                :placeholder="$t('Enter Sub Category Name')"
              />
              <span class="text-error" v-if="errors.has('subcategoryname')">{{
                errors.first('subcategoryname')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditSubCategory">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="editSubCategory">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex; align-items: stretch">
        <div class="move-vertical text-xs-center">
          <slot name="move"></slot>
        </div>
        <div
          class="category-name text-truncate form-control ignore-elements"
          style="display: flex; align-items: center"
        >
          <div v-if="subcategory.photo_url" class="pr-4">
            <img :src="subcategory.photo_url" style="width: 70px; height: auto" />
          </div>
          <div>{{ subcategory.name }}</div>
        </div>
        <div class="action text-xs-right ignore-elements">
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            v-if="!editText"
            @click="onEditSubCategory"
          >
            <em class="fa fa-pencil-alt" aria-hidden="true" />
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            @click="onDeleteSubCategory"
          >
            <em class="fa fa-trash" aria-hidden="true" />
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import uploadfile from '@/components/elements/uploadfile'

export default {
  props: ['value', 'subcategorylist'],
  data: function () {
    return {
      subcategory: undefined,
      editText: false,
      isLoading: false
    }
  },
  mounted: function () {
    var vm = this

    vm.subcategory = vm.value
    vm.cached_subcategory = JSON.stringify(vm.value)
  },
  components: {
    PulseLoader,
    uploadfile
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    subcategoryname() {
      return this.subcategorylist.filter((v) => v.id !== this.value.id).map((v) => v.name)
    },
    subcategoryphoto() {
      return this.subcategorylist.filter((v) => v.id !== this.value.id).map((v) => v.photo_url)
    }
  },
  methods: {
    onDeleteSubCategory: function () {
      this.$emit('onDelete', this.subcategory.id)
    },
    pressEnter: function () {
      if (e.keyCode === 13) {
        this.editSubCategory()
      }
    },
    onCancelEditSubCategory: function () {
      var vm = this
      vm.subcategory = JSON.parse(vm.cached_subcategory)
      vm.$emit('input', vm.subcategory)
      vm.editText = false
    },
    onEditSubCategory: function () {
      var vm = this
      vm.editText = true
      vm.$nextTick(function () {
        if (vm.subcategory && vm.editText) {
          vm.$refs.category.focus()
        }
      })
    },
    editSubCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        let data = {
          name: vm.subcategory.name,
          sub_category_id: vm.subcategory.id,
          pageid: vm.selectedBot.pageid,
          photo_url: vm.subcategory.photo_url
        }

        vm.isLoading = true
        api.putLamyGiftSubCategory(data, function (error, response) {
          vm.isLoading = false
          vm.editText = false
          vm.cached_subcategory = JSON.stringify(vm.subcategory)
          vm.$emit('input', vm.subcategory)
          vm.$emit('close')
        })
      })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal) {
        this.subcategory = this.value
        this.cached_subcategory = JSON.stringify(this.value)
        // this.$refs.tagInput.innerText = this.value.name
      }
      // this.text = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.move-vertical {
  border-right: 1px solid #eee;
  padding: 10px;
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ecommerce-sub-category-edit.vue